export enum TagIdentifier {
  AAVE = 'aave',
  BALANCER = 'balancer',
  COMPOUND = 'compound',
  CURVE = 'curve',
}
